var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosofttodo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "144px",
    height: "144px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0d47a1",
    d: "M21.25,40.454l6.13-6.142c0.694-0.696,0.694-1.823,0-2.519L11.165,15.547 c-0.694-0.696-1.82-0.696-2.514,0l-6.13,6.142c-0.694,0.696-0.694,1.823,0,2.519l16.215,16.246 C19.43,41.15,20.555,41.15,21.25,40.454z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#29b6f6",
    d: "M18.788,40.498l-6.223-6.235c-0.669-0.67-0.669-1.756,0-2.426L35.854,8.502 c0.669-0.67,1.753-0.67,2.421,0l6.223,6.235c0.669,0.67,0.669,1.756,0,2.426L21.209,40.498 C20.541,41.167,19.457,41.167,18.788,40.498z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosofttodo);
export default __webpack_public_path__ + "static/media/Microsoft to do.16fa90b48f17725e60983e9a5e04b5c0.svg";
export { ForwardRef as ReactComponent };